<p-dialog
    [(visible)]="visible"
    [appendTo]="appendTo"
    [breakpoints]="{ '960px': '600px', '640px': 'calc(100% - 40px)' }"
    [closable]="false"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
    (onHide)="onHide()"
    (onShow)="onShow()"
    styleClass="general-dialog"
>
    <ng-template #header>
        @if (visible && options) {
            <div class="flex align-center">
                @if (options.icon) {
                    <div>
                        <app-svg-icon [icon]="options.icon"> </app-svg-icon>
                    </div>
                }
                <div class="ml-8">
                    {{ options.title | translate }}
                </div>
            </div>
        }
    </ng-template>

    @if (visible) {
        <div class="p-16">
            <p [innerHTML]="options.body | translate | safeHtml"></p>
            @if (options.image) {
                <img [src]="options.image | safeHtml" />
            }
        </div>
    }

    <ng-template #footer>
        @if (visible && options) {
            @if (options.doNotShowAgainVisible) {
                <label class="label-checkbox m-input-checkbox mr-8">
                    <input
                        id="dialog-doNotShowAgain"
                        [(ngModel)]="options.doNotShowAgain"
                        type="checkbox"
                    />
                    {{ "form.doNotShowAgain" | translate }}
                </label>
            }
            @if (options.rejectVisible) {
                <button
                    class="m-btn m-btn-default"
                    id="buttonDialogReject"
                    (click)="reject()"
                    type="button"
                >
                    {{ "form.cancel" | translate }}
                </button>
            }
            @if (options.acceptVisible) {
                <button
                    class="m-btn m-btn-primary"
                    id="buttonDialogAccept"
                    (click)="accept()"
                    type="submit"
                >
                    {{ options.acceptLabel | translate }}
                </button>
            }
        }
    </ng-template>
</p-dialog>
